import React, { useState, useEffect } from 'react';
import './cookiepopup.css';

const CookiePopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted');
    const declined = localStorage.getItem('cookiesDeclined');
    if (!accepted && !declined) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    localStorage.removeItem('cookiesDeclined');
    setVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookiesDeclined', 'true');
    localStorage.removeItem('cookiesAccepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-popup-overlay">
      <div className="cookie-popup">
        <p style={{fontSize: "1.6rem"}}>Cookies help us improve your experience</p>
        <p>
          We use the following cookies to improve website functionality and performance.{' '}
          Read our{' '}
          <a href="/cookie-policy" className="cookie-link">Cookie Policy</a>
          {' '}and{' '}
          <a href="/privacypolicy" className="cookie-link">Privacy Policy</a>
          {' '}for more information.
        </p>
        <ul className="cookie-list" style={{listStyleType: "none"}}>
          <li>Strictly necessary cookies are essential for you to browse the website and use its core features.</li>
          <li>Functional cookies help us understand how you use our site, like which pages you visited, so we can improve website functionality.</li>
          <li>Targeting or advertising cookies are typically provided by third parties, such as social networks, to help deliver relevant content for you.</li>
        </ul>
        <div className="cookie-btn-group">
          <button className="cookie-decline-btn" onClick={declineCookies}>Decline</button>
          <button className="cookie-accept-btn" onClick={acceptCookies}>Accept All Cookies</button>
        </div>
      </div>
    </div>
  );
};

export default CookiePopup;
